import EssenceAnimatedRow from '../../components/essence/row/animated-row';
import { Expense } from '../../shared/models/expense';

interface Props {
	expense: Expense;
	loggedInUserId: string;
}
export default function ExpenseRow({ expense, loggedInUserId }: Props) {
	const _getSubtitle = (expense: Expense) => {
		if (expense.creditors) {
			const paidBy = expense.creditors.map(x => (x.id === loggedInUserId ? 'You' : x.name)).join(', ');
			return `<span>Date: ${expense.dateTime?.toLocaleDateString() ?? '-'}  <br>Paid By: ${paidBy}</span>`;
		}
	};

	// const _getSettlementSubtitle = (expense: Expense) => {
	// 	return `Date: ${expense.dateTime?.toLocaleDateString() ?? '-'}`;
	// };

	const _getSettlementDescription = (expense: Expense) => {
		if (expense.creditors && expense.debtors) {
			const paidBy = expense.creditors.map(x => (x.id === loggedInUserId ? 'You' : x.name)).join(', ');
			const paidTo = expense.debtors.map(x => (x.id === loggedInUserId ? 'you' : x.name)).join(', ');
			return `-- ${paidBy} paid ${paidTo} ${expense.currency ?? '₹'}${expense.amount.toString()} on ${expense.dateTime?.toLocaleDateString() ?? '-'} --`;
		}
	};
	return (
		<>
			{!expense.isSettlement && (
				<EssenceAnimatedRow
					title={expense.description}
					subTitle={_getSubtitle(expense)}
					actionText={`${expense.currency ?? ''}${expense.amount.toString()}`}
				/>
			)}
			{expense.isSettlement && (
				// <EssenceAnimatedRow
				// 	title={_getSettlementDescription(expense)}
				// 	subTitle={_getSettlementSubtitle(expense)}
				// 	actionText={`${expense.currency ?? ''} ${expense.amount.toString()}`}
				// />
				<div className="caption my-8">{_getSettlementDescription(expense)}</div>
			)}
		</>
	);
}
